import { render, staticRenderFns } from "./BrickSquare.vue?vue&type=template&id=e6ac0720&scoped=true&"
import script from "./BrickSquare.vue?vue&type=script&lang=js&"
export * from "./BrickSquare.vue?vue&type=script&lang=js&"
import style0 from "./BrickSquare.vue?vue&type=style&index=0&id=e6ac0720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ac0720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6ac0720')) {
      api.createRecord('e6ac0720', component.options)
    } else {
      api.reload('e6ac0720', component.options)
    }
    module.hot.accept("./BrickSquare.vue?vue&type=template&id=e6ac0720&scoped=true&", function () {
      api.rerender('e6ac0720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickSquare.vue"
export default component.exports